import { DataType, TableName } from '../../../tables'
import { RangeParams, Params } from '../../../state/reducers/types'
import { DynamoUserApi } from '../../../services'
import { useStateHooks } from '../../../state'
import { useDefaultDbActions } from './defaultDbActions'
import { O } from '../../../features/ui'
import { toList } from '../../../utils/listUtils'
import { QueryOptions } from '../../../services/dynamo'

export const useFetchActions = () => {
    const { getUpdater } = useStateHooks()

    const defaultDbActions = useDefaultDbActions()

    const updater = (tableName: TableName) => getUpdater(tableName) as any as O<(list: DataType[]) => void>

    return (companyId?: string, dynamoApi = DynamoUserApi) => {
        const fetchMultiple = async (
            table: TableName,
            options?: QueryOptions
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const response = await dbActions.getMultiple(table, options)
            const list = response.dataTypes
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return response
        }

        const count2 = async (
            table: TableName,
            options?: QueryOptions
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            return dbActions.count2(table, options)
        }

        // TODO analizar los de abajo de esta linea 1 por 1 si se puede reemplazar por getMultiple
        // los que no, implementar con mismo criterio que getMultiple
        
        const fetchAll = async (table: TableName) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const list = await dbActions.getAll(table)
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return list
        }

        const fetchBatch = async (
            table: TableName,
            startKey?: Params,
            limit?: number
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const response = await dbActions.getBatch(table, startKey, limit)
            const list = response.dataTypes
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return response
        }

        const fetchAllProps = async (
            table: TableName,
            propName: string
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            return dbActions.getAll(table, propName)
        }

        const fetch = async (
            table: TableName,
            id: string
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const item = await dbActions.get(table, id)
            if (item) {
                const update = updater(table)
                update && update(toList(item))
            }
            return item
        }

        const fetchByIds = async (
            table: TableName,
            ids: string[]
        ) => {
            if (ids.length === 0) {
                return []
            }
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const list = await dbActions.getByIds(table, ids)
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return list
        }

        const fetchFiltered = async (
            table: TableName,
            params?: Params,
            ranges?: RangeParams,
            existingParams?: string[]
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const list = await dbActions.getFiltered(table, params, ranges, existingParams)
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return list
        }

        const fetchFilteredByList = async (
            table: TableName,
            key: string,
            values: string[]
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            const list = await dbActions.getFilteredByList(table, key, values)
            if (list.length > 0) {
                const update = updater(table)
                update && update(list)
            }
            return list
        }

        const count = (
            table: TableName,
            startKey?: Params,
            limit?: number,
            params?: Params
        ) => {
            const dbActions = defaultDbActions(dynamoApi, companyId)
            return dbActions.count(table, startKey, limit, params)
        }

        return {
            fetchMultiple,
            count2,

            fetchAll,
            fetchBatch,
            fetchAllProps,
            fetch,
            fetchByIds,
            fetchFiltered,
            fetchFilteredByList,
            count
        }
    }
}
